import React from "react";
import DiamondIcon from "@/assets/icons/diamond.svg";
import { twMerge } from "tailwind-merge";
import { getClasses } from "../helpers";

export interface Props {
  color: string;
  points: number;
}

const QuestPoints = ({ color, points }: Props) => {
  const { bgClass, textHoverClass, iconHoverClass } = getClasses(color);

  return (
    <div
      className={twMerge(
        `h-10 flex items-center rounded-[20px] p-3 mr-auto group-hover:bg-white endemic:bg-black`,
        bgClass,
      )}
    >
      <DiamondIcon
        className={twMerge(
          `fill-white endemic:group-hover:fill-black w-5 h-5`,
          iconHoverClass,
        )}
      />
      <span
        className={twMerge(
          `text-[15px] text-white endemic:group-hover:text-black font-semibold ml-2 whitespace-nowrap`,
          textHoverClass,
        )}
      >
        {`${points} XP`}
      </span>
    </div>
  );
};

export default QuestPoints;
